import type { HTMLProps } from 'react';
import type { Control } from 'react-hook-form';

import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Field, Input } from '~/components/Form';

type FormWithCompanyName = { companyName: string };

export const FormCompanyName = <T extends FormWithCompanyName>({
  control,
  ...props
}: HTMLProps<HTMLDivElement> & {
  control: T extends FormWithCompanyName ? Control<T> : never;
}) => {
  const { t } = useTranslation(['clients', 'validation']);

  return (
    <div {...props}>
      <Controller
        control={control as Control<FormWithCompanyName>}
        name="companyName"
        render={({ field: { name, onBlur, onChange, ref, value }, fieldState: { error, invalid, isDirty, isTouched } }) => (
          <Field.Root dirty={isDirty} invalid={invalid} name={name} touched={isTouched}>
            <Field.Label>{t('clients:fields.companyName.label')}</Field.Label>

            <Input onBlur={onBlur} onValueChange={onChange} ref={ref} value={value} />

            <Field.Error match={!!error}>{error?.message}</Field.Error>
          </Field.Root>
        )}
        rules={{
          required: { value: true, message: t('validation:required') },
          validate: (value) => !!value.trim() || t('validation:required'),
        }}
      />
    </div>
  );
};
